import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const usuProfesionesApi = `${baseUrl}/usuario-profesiones`;

export const allUsuProfesionesService = async (params) => {
  const res = await axios.get(usuProfesionesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveUsuProfesionesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${usuProfesionesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(usuProfesionesApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const deleteUsuProfesionesService = async (id) => {
  const res = await axios.delete(`${usuProfesionesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
